import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'

Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */





// hreflang配置
const hreflangLinks = [
	{ rel: 'alternate', hreflang: 'en', href: 'https://gbwaap.com/' },
	{ rel: 'alternate', hreflang: 'hi', href: 'https://gbwaap.com/in/' },
	{ rel: 'alternate', hreflang: 'es', href: 'https://gbwaap.com/es/' },
	{ rel: 'alternate', hreflang: 'pt', href: 'https://gbwaap.com/pt/' },
	{ rel: 'alternate', hreflang: 'id', href: 'https://gbwaap.com/id/' },
	{ rel: 'alternate', hreflang: 'x-default', href: 'https://gbwaap.com/' }
]

// 动态导入视图
const views = {
	Home: () => import('@/views/home.vue'),
	Download: () => import('@/views/download.vue'),
	Blogs: () => import('@/views/blogs.vue'),
	Fmwhatsapp: () => import('@/views/fmwhatsapp.vue'),
	Yowhatsapp: () => import('@/views/yowhatsapp.vue'),
	Ogwhatsapp: () => import('@/views/ogwhatsapp.vue'),
	Jtwhatsapp: () => import('@/views/jtwhatsapp.vue'),
	Mbwhatsapp: () => import('@/views/mbwhatsapp.vue'),
	WhatsappPlus: () => import('@/views/whatsapp-plus.vue'),
	GoldWhatsapp: () => import('@/views/gold-whatsapp.vue'),
	RedWhatsapp: () => import('@/views/red-whatsapp.vue'),
	BlueWhatsapp: () => import('@/views/blue-whatsapp.vue'),
	About: () => import('@/views/about.vue'),
	Contact: () => import('@/views/contact.vue'),
	Privacy: () => import('@/views/privacy.vue'),
	Terms: () => import('@/views/terms-of-service.vue'),
	Dmca: () => import('@/views/dmca.vue'),
	Disclaimer: () => import('@/views/disclaimer.vue'),
	Blog1: () => import('@/views/blog-1.vue'),
	Blog2: () => import('@/views/blog-2.vue'),
	Blog3: () => import('@/views/blog-3.vue'),
	Blog4: () => import('@/views/blog-4.vue'),
	Blog5: () => import('@/views/blog-5.vue'),
	Blog6: () => import('@/views/blog-6.vue'),
	Blog7: () => import('@/views/blog-7.vue'),
	Blog8: () => import('@/views/blog-8.vue'),
	Blog9: () => import('@/views/blog-9.vue'),
	Blog10: () => import('@/views/blog-10.vue'),
}

// English路由
export const constRoutesPc = [
	// 首页
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GBWhatsApp APK Download Latest Version 2026',
			keywords: 'gbwhatsapp, gb whatsapp, gb whatsapp download, gbwhatsapp apk',
			description: 'Download GBWhatsApp APK latest version with anti-ban protection. Learn features, installation steps, and safe download guide for GB WhatsApp 2026.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/' },
				...hreflangLinks
			]
		},
		component: Home,
	},
	// Download页面
	{
		path: '/download/',
		name: 'en-download',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Download GBWhatsApp APK & WhatsApp MODs Latest Versions 2026',
			keywords: 'gbwhatsapp download, whatsapp mod apk download, gb whatsapp apk',
			description: 'Download GBWhatsApp APK and other WhatsApp MOD apps like FMWhatsApp, YoWhatsApp, and WhatsApp Plus. Get the latest versions with installation guides.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/download/' },
				...hreflangLinks
			]
		},
		component: views.Download,
	},
	// MOD页面
	{
		path: '/fmwhatsapp/',
		name: 'en-fmwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: 'FMWhatsApp APK Download Latest Version 2026',
			keywords: 'fmwhatsapp, fm whatsapp apk download, fmwhatsapp mod',
			description: 'Download FMWhatsApp APK latest version. Learn about features, installation guide, and how FMWhatsApp compares to GBWhatsApp and other WhatsApp mods.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/fmwhatsapp/' },
				...hreflangLinks
			]
		},
		component: views.Fmwhatsapp,
	},
	{
		path: '/yowhatsapp/',
		name: 'en-yowhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: 'YoWhatsApp APK Download Latest Version 2026',
			keywords: 'yowhatsapp, yo whatsapp apk download, yowhatsapp mod',
			description: 'Download YoWhatsApp APK latest version. Discover features, installation steps, and compare with GBWhatsApp and other WhatsApp modifications.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/yowhatsapp/' },
				...hreflangLinks
			]
		},
		component: views.Yowhatsapp,
	},
	{
		path: '/ogwhatsapp/',
		name: 'en-ogwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: 'OGWhatsApp APK Download Latest Version 2026',
			keywords: 'ogwhatsapp, og whatsapp apk download, ogwhatsapp mod',
			description: 'Download OGWhatsApp APK latest version. Learn about unique features and how it compares to other WhatsApp mods.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/ogwhatsapp/' },
				...hreflangLinks
			]
		},
		component: views.Ogwhatsapp,
	},
	{
		path: '/jtwhatsapp/',
		name: 'en-jtwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: 'JTWhatsApp APK Download Latest Version 2026',
			keywords: 'jtwhatsapp, jt whatsapp apk download, jtwhatsapp mod',
			description: 'Download JTWhatsApp APK latest version. Discover features and installation guide for this WhatsApp modification.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/jtwhatsapp/' },
				...hreflangLinks
			]
		},
		component: views.Jtwhatsapp,
	},
	{
		path: '/mbwhatsapp/',
		name: 'en-mbwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: 'MBWhatsApp APK Download Latest Version 2026',
			keywords: 'mbwhatsapp, mb whatsapp apk download, mbwhatsapp mod',
			description: 'Download MBWhatsApp APK latest version. Learn about features and how to install this WhatsApp mod.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/mbwhatsapp/' },
				...hreflangLinks
			]
		},
		component: views.Mbwhatsapp,
	},
	{
		path: '/whatsapp-plus/',
		name: 'en-whatsapp-plus',
		meta: {
			appname: 'GBWhatsApp',
			title: 'WhatsApp Plus APK Download Latest Version 2026',
			keywords: 'whatsapp plus, whatsapp plus apk download, whatsapp plus mod',
			description: 'Download WhatsApp Plus APK latest version. Discover features, installation guide, and compare with GBWhatsApp.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/whatsapp-plus/' },
				...hreflangLinks
			]
		},
		component: views.WhatsappPlus,
	},
	{
		path: '/gold-whatsapp/',
		name: 'en-gold-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Gold WhatsApp APK Download Latest Version 2026',
			keywords: 'gold whatsapp, gold whatsapp apk download, gold whatsapp mod',
			description: 'Download Gold WhatsApp APK latest version. Learn about premium features and installation guide.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/gold-whatsapp/' },
				...hreflangLinks
			]
		},
		component: views.GoldWhatsapp,
	},
	{
		path: '/red-whatsapp/',
		name: 'en-red-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Red WhatsApp APK Download Latest Version 2026',
			keywords: 'red whatsapp, red whatsapp apk download, red whatsapp mod',
			description: 'Download Red WhatsApp APK latest version. Discover unique red theme features and installation guide.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/red-whatsapp/' },
				...hreflangLinks
			]
		},
		component: views.RedWhatsapp,
	},
	{
		path: '/blue-whatsapp/',
		name: 'en-blue-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Blue WhatsApp APK Download Latest Version 2026',
			keywords: 'blue whatsapp, blue whatsapp apk download, blue whatsapp mod',
			description: 'Download Blue WhatsApp APK latest version. Learn about blue theme features and installation guide.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blue-whatsapp/' },
				...hreflangLinks
			]
		},
		component: views.BlueWhatsapp,
	},
	// Blog页面
	{
		path: '/blog/',
		name: 'en-blog',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GBWhatsApp Blog - Latest News and Guides',
			keywords: 'gbwhatsapp blog, whatsapp mod news, gbwhatsapp guide',
			description: 'Read the latest articles about GBWhatsApp, WhatsApp mods, installation guides, and tips.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blog/' },
				...hreflangLinks
			]
		},
		component: views.Blogs,
	},
	// 博客文章页面
	{
		path: '/blog/best-whatsapp-mod-apps/',
		name: 'en-blog-1',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Best WhatsApp Mod Apps in 2026 - Complete Guide',
			keywords: 'whatsapp mod, gbwhatsapp, fmwhatsapp, yowhatsapp, whatsapp plus',
			description: 'Discover the best WhatsApp mod apps in 2026. Compare GBWhatsApp, FMWhatsApp, YoWhatsApp, and WhatsApp Plus.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blog/best-whatsapp-mod-apps/' },
				...hreflangLinks
			]
		},
		component: views.Blog1,
	},
	{
		path: '/blog/gbwhatsapp-privacy-tips/',
		name: 'en-blog-2',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GBWhatsApp Privacy Tips and Tricks',
			keywords: 'gbwhatsapp privacy, hide online status, hide blue ticks',
			description: 'Learn how to use GBWhatsApp privacy features to hide online status, blue ticks, and more.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blog/gbwhatsapp-privacy-tips/' },
				...hreflangLinks
			]
		},
		component: views.Blog2,
	},
	{
		path: '/blog/gbwhatsapp-vs-fmwhatsapp/',
		name: 'en-blog-3',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GBWhatsApp vs FMWhatsApp - Complete Comparison',
			keywords: 'gbwhatsapp vs fmwhatsapp, whatsapp mod comparison',
			description: 'Compare GBWhatsApp and FMWhatsApp features, privacy, updates and more.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blog/gbwhatsapp-vs-fmwhatsapp/' },
				...hreflangLinks
			]
		},
		component: views.Blog3,
	},
	{
		path: '/blog/gbwhatsapp-vs-whatsapp-official/',
		name: 'en-blog-4',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GBWhatsApp vs WhatsApp Official - Complete Comparison 2026',
			keywords: 'gbwhatsapp vs whatsapp official, whatsapp mod vs official',
			description: 'Compare GBWhatsApp with WhatsApp Official. Learn the differences in features, privacy, and customization.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blog/gbwhatsapp-vs-whatsapp-official/' },
				...hreflangLinks
			]
		},
		component: views.Blog4,
	},
	{
		path: '/blog/gbwhatsapp-vs-yowhatsapp/',
		name: 'en-blog-5',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GBWhatsApp vs YoWhatsApp - Complete Comparison',
			keywords: 'gbwhatsapp vs yowhatsapp, whatsapp mod comparison',
			description: 'Compare GBWhatsApp and YoWhatsApp features, themes, and anti-ban protection.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blog/gbwhatsapp-vs-yowhatsapp/' },
				...hreflangLinks
			]
		},
		component: views.Blog5,
	},
	{
		path: '/blog/how-to-backup-gbwhatsapp-chat/',
		name: 'en-blog-6',
		meta: {
			appname: 'GBWhatsApp',
			title: 'How to Backup GBWhatsApp Chat History - Complete Guide',
			keywords: 'gbwhatsapp backup, backup chat history, google drive backup',
			description: 'Learn how to backup and restore GBWhatsApp chat history using local and Google Drive backup.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blog/how-to-backup-gbwhatsapp-chat/' },
				...hreflangLinks
			]
		},
		component: views.Blog6,
	},
	{
		path: '/blog/how-to-fix-gbwhatsapp-login-problem/',
		name: 'en-blog-7',
		meta: {
			appname: 'GBWhatsApp',
			title: 'How to Fix GBWhatsApp Login Problems',
			keywords: 'gbwhatsapp login issues, fix login, verification code',
			description: 'Troubleshoot common GBWhatsApp login problems and verification issues.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blog/how-to-fix-gbwhatsapp-login-problem/' },
				...hreflangLinks
			]
		},
		component: views.Blog7,
	},
	{
		path: '/blog/how-to-transfer-whatsapp-to-gbwhatsapp/',
		name: 'en-blog-8',
		meta: {
			appname: 'GBWhatsApp',
			title: 'How to Transfer WhatsApp to GBWhatsApp',
			keywords: 'transfer whatsapp to gbwhatsapp, migrate chats',
			description: 'Learn how to transfer your WhatsApp chats to GBWhatsApp safely.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blog/how-to-transfer-whatsapp-to-gbwhatsapp/' },
				...hreflangLinks
			]
		},
		component: views.Blog8,
	},
	{
		path: '/blog/is-gbwhatsapp-legal/',
		name: 'en-blog-9',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Is GBWhatsApp Legal? Everything You Need to Know',
			keywords: 'gbwhatsapp legal, is gbwhatsapp legal',
			description: 'Understand the legal status of GBWhatsApp and important considerations before using it.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blog/is-gbwhatsapp-legal/' },
				...hreflangLinks
			]
		},
		component: views.Blog9,
	},
	{
		path: '/blog/is-gb-whatsapp-still-working-2026/',
		name: 'en-blog-10',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Is GB WhatsApp Still Working in 2026?',
			keywords: 'is gb whatsapp still working, gb whatsapp banned, gbwhatsapp 2026',
			description: 'Is GB WhatsApp being banned? Find out whether GB WhatsApp still works in 2026, why users are facing restrictions, and what to do if it stops working.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/blog/is-gb-whatsapp-still-working-2026/' },
				...hreflangLinks
			]
		},
		component: views.Blog10,
	},
	// 系统页面
	{
		path: '/about/',
		name: 'en-about',
		meta: {
			appname: 'GBWhatsApp',
			title: 'About GBWhatsApp',
			keywords: 'about gbwhatsapp, about us',
			description: 'Learn more about GBWhatsApp and our mission to provide the best WhatsApp mod experience.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/about/' },
				...hreflangLinks
			]
		},
		component: views.About,
	},
	{
		path: '/contact/',
		name: 'en-contact',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Contact Us',
			keywords: 'contact gbwhatsapp, contact us',
			description: 'Get in touch with us for any questions about GBWhatsApp or WhatsApp mods.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/contact/' },
				...hreflangLinks
			]
		},
		component: views.Contact,
	},
	{
		path: '/privacy/',
		name: 'en-privacy',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Privacy',
			keywords: 'privacy, gbwhatsapp privacy',
			description: 'Read our privacy policy to understand how we protect your data.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/privacy/' },
				...hreflangLinks
			]
		},
		component: views.Privacy,
	},
	{
		path: '/privacy-policy/',
		name: 'en-privacy-policy',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Privacy Policy',
			keywords: 'privacy policy, gbwhatsapp privacy',
			description: 'Read our privacy policy to understand how we protect your data.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/privacy-policy/' },
				...hreflangLinks
			]
		},
		component: views.Privacy,
	},
	{
		path: '/terms-of-service/',
		name: 'en-terms-of-service',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Terms of Service',
			keywords: 'terms of service, gbwhatsapp terms',
			description: 'Read our terms of service for using GBWhatsApp.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/terms-of-service/' },
				...hreflangLinks
			]
		},
		component: views.Terms,
	},
	{
		path: '/dmca/',
		name: 'en-dmca',
		meta: {
			appname: 'GBWhatsApp',
			title: 'DMCA',
			keywords: 'dmca, copyright',
			description: 'DMCA copyright information for GBWhatsApp.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/dmca/' },
				...hreflangLinks
			]
		},
		component: views.Dmca,
	},
	{
		path: '/disclaimer/',
		name: 'en-disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Disclaimer',
			keywords: 'disclaimer, gbwhatsapp disclaimer',
			description: 'Disclaimer for using GBWhatsApp and WhatsApp mods.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/disclaimer/' },
				...hreflangLinks
			]
		},
		component: views.Disclaimer,
	},

	// ========== Hindi版本 (/in/) ==========
	{
		path: '/in/',
		name: 'hi-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GBWhatsApp APK डाउनलोड नवीनतम संस्करण 2026',
			keywords: 'gbwhatsapp, gb whatsapp, gb whatsapp डाउनलोड, gbwhatsapp apk',
			description: 'GBWhatsApp APK का नवीनतम संस्करण डाउनलोड करें। फीचर्स, इंस्टॉलेशन गाइड और सुरक्षित डाउनलोड जानकारी प्राप्त करें।',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/in/' },
				...hreflangLinks
			]
		},
		component: Home,
	},
	// ========== Spanish版本 (/es/) ==========
	{
		path: '/es/',
		name: 'es-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Descargar GBWhatsApp APK Última Versión 2026',
			keywords: 'gbwhatsapp, gb whatsapp, descargar gbwhatsapp, gbwhatsapp apk',
			description: 'Descarga GBWhatsApp APK última versión con funciones avanzadas y guía de instalación segura.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/es/' },
				...hreflangLinks
			]
		},
		component: Home,
	},
	// ========== Portuguese版本 (/pt/) ==========
	{
		path: '/pt/',
		name: 'pt-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Baixar WhatsApp GB APK Ultima Versao 2026',
			keywords: 'whatsapp gb, gb whatsapp, baixar whatsapp gb, whatsapp gb apk',
			description: 'Baixe WhatsApp GB APK ultima versao com recursos avancados e guia de instalacao seguro.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/pt/' },
				...hreflangLinks
			]
		},
		component: Home,
	},
	// ========== Indonesian版本 (/id/) ==========
	{
		path: '/id/',
		name: 'id-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Download WA GB APK Versi Terbaru 2026',
			keywords: 'wa gb, gb whatsapp, whatsapp gb, download wa gb, wa gb apk',
			description: 'Download WA GB APK versi terbaru dengan fitur lengkap dan panduan instalasi yang aman.',
			link: [
				{ rel: 'canonical', href: 'https://gbwaap.com/id/' },
				...hreflangLinks
			]
		},
		component: Home,
	},
]

let routes = []

routes = constRoutesPc

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
